module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dayWrapper"
  }, [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('div', {
    staticClass: "dayToggle"
  }, [_c('router-link', {
    staticClass: "material-icons action-icon",
    attrs: {
      "to": '/day/' + _vm.yesterday
    }
  }, [_vm._v("\n        keyboard_arrow_left\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "material-icons action-icon",
    attrs: {
      "to": '/day/' + _vm.tomorrow
    }
  }, [_vm._v("\n        keyboard_arrow_right\n      ")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "editLink",
    attrs: {
      "to": "edit",
      "append": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.inEditMode ? " " : "EDIT"))])], 1), _vm._v(" "), _vm._l((_vm.categories), function(category, key) {
    return (!category.parentId) ? [_c('div', {
      class: ['flexRow category', category.children && category.showChildren ? 'parent' : '']
    }, [_c('category-details-block', {
      attrs: {
        "category": category,
        "completed": _vm.getCategoryCompleted(key, _vm.date),
        "quota": _vm.getCategoryQuota(key)
      }
    }), _vm._v(" "), (_vm.inEditMode) ? _c('current-blocks', {
      staticClass: "currentBlocks",
      attrs: {
        "blocks": _vm.getCategoryBlocks(key),
        "category": category.name,
        "quota": _vm.getCategoryQuota(key, _vm.date, false),
        "color": category.color,
        "categoryId": key,
        "isContinuous": _vm.inEditMode,
        "customDate": _vm.date
      }
    }) : _c('static-block-row', {
      attrs: {
        "color": category.color,
        "quota": _vm.getCategoryQuota(key, _vm.date, false),
        "completed": Object.keys(_vm.getCategoryBlocks(key) || {}).length
      }
    })], 1), _vm._v(" "), (category.showChildren) ? _vm._l((Object.keys(category.children || {})), function(childId) {
      return _c('div', {
        staticClass: "flexRow subcategory"
      }, [_c('subcategory-details-block', {
        attrs: {
          "categoryId": childId
        }
      }), _vm._v(" "), (_vm.inEditMode) ? _c('current-blocks', {
        staticClass: "currentBlocks",
        attrs: {
          "blocks": _vm.isToday ? _vm.categories[childId].blocks : _vm.blocks[childId],
          "category": _vm.categories[childId].name,
          "quota": _vm.getCategoryQuota(childId, _vm.date, false),
          "color": _vm.categories[childId].color,
          "categoryId": childId,
          "isContinuous": _vm.inEditMode,
          "customDate": _vm.date
        }
      }) : _c('static-block-row', {
        attrs: {
          "color": _vm.categories[childId].color,
          "quota": _vm.getCategoryQuota(childId, _vm.date, false),
          "completed": Object.keys((_vm.isToday ? _vm.categories[childId].blocks : _vm.blocks[childId]) || {}).length
        }
      })], 1)
    }) : _vm._e()] : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f55d1132!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/DayView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-f55d1132!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/DayView.vue
// module chunks = 0